// Data
export const SET_AREAS = 'SET_AREAS';
export const SET_CLASS_STEPS = 'SET_CLASS_STEPS';
export const SET_POLLS = 'SET_POLLS'
export const SET_UID = 'SET_UID';
export const SET_CURRENT_POLL_ID = 'SET_CURRENT_POLL_ID';
export const SET_ERROR = 'SET_ERROR';